import React,{Component} from 'react';
import 'tachyons';
import face from './aditya.jpg'

class Face extends Component{
	render(){
		return<img className="br-100" src={face} alt="Aditya" />
	}
}

export default Face;
